<template>
  <ul class="screen-filters">
    <li
      v-for="(btn, idx) in filterBtns"
      :key="'filter' + idx"
      class="screen-filters__btn"
      :class="{ active: btn.active }"
      :style="{
        background: btn.active
          ? settings.filter.activeColor
          : bgColor,
        flexDirection: btn.iconPlacement === 'start' ? 'row' : 'row-reverse',
      }"
    >
      <a-icon
        v-if="btn.icon"
        :type="btn.icon"
        :style="{
          color: btn.active
            ? settings.filter.contentColor
            : settings.main.iconColor,
        }"
      />
      <span
        v-if="btn.text"
        :style="{
          color: btn.active
            ? settings.filter.contentColor
            : settings.main.textColor,
        }"
        >{{ btn.text }}</span
      >
    </li>
  </ul>
</template>
<script>
import { gradientBackground } from '@/services/utils/custom-pages'

export default {
  props: {
    filterBtns: {
      type: Array,
      default: () => [],
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
  computed: {
    bgColor() {
      return this.settings?.main?.fill === 'gradient'
        ? gradientBackground(
            this.settings?.main?.mainColor,
            this.settings?.schema,
        )
        : this.settings?.main?.mainColor
    },
  },
}
</script>
<style scoped lang="scss">
.screen-filters {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 0 5px 10px;

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    border-radius: 5px;
    padding: 5px;
    font-weight: 500;
    font-size: 8px;
    line-height: 10px;

    i,
    svg {
      font-size: 10px;
      width: 10px;
      height: 10px;
    }
  }
}
</style>
